
export default {
  name: 'LayoutContainer',
  computed: {
    routeName() {
      const pathTitle = this.$route.path.split('/').filter(Boolean)
      return ['Page', ...pathTitle].join(' ')
    }
  }
}
